import { forwardRef } from 'react'

import { TooltipCompat as TooltipInternal } from '@adverity/ds-core/tooltip/compat'

import type { IconButtonProps } from './types'
import { getIconButtonProps } from './utils'
import { ButtonMinimalInternal } from '../button/button-minimal-internal'

type Props = IconButtonProps & {
    isTooltipVisible?: boolean
}

export const IconButtonMinimalInternal = forwardRef<HTMLButtonElement, Props>(
    ({ label, isTooltipVisible, ...props }, ref) => (
        <TooltipInternal title={label} visible={isTooltipVisible}>
            <ButtonMinimalInternal ref={ref} aria-label={label} {...getIconButtonProps(props)} />
        </TooltipInternal>
    ),
)

IconButtonMinimalInternal.displayName = 'IconButtonMinimalInternal'
